import { BaseUrl, ChatBaseUrl, MetaBaseUrl } from "../Constant/Setting"

// Auth zeaiq plus
export const REGISTER_INDIVIDUAL = BaseUrl + "/auth/register/individual"
export const LOGIN = BaseUrl + "/auth/login"
export const REGENERATE_ACCESS_TOKEN = BaseUrl + "/auth/get-access-token"
export const ME = BaseUrl + "/auth/me"
export const SEND_OTP = BaseUrl + "/auth/otp/send"
export const OTP_VERIFY = BaseUrl + "/auth/otp/verify"
export const RE_SEND_OTP = BaseUrl + "/auth/otp/resend"

export const MFA_SETUP = BaseUrl + "/auth/mfa/setup"
export const MFA_ENABLE = BaseUrl + "/auth/mfa/enable"
export const MFA_VERIFY = BaseUrl + "/auth/mfa/verify"
export const MFA_DISABLE = BaseUrl + "/auth/mfa/disable"

export const UPLOAD_PROFILE_IMAGE = BaseUrl + "/auth/upload-profile-image"
export const DELETE_PROFILE_IMAGE = BaseUrl + "/auth/delete-profile-image"


// Microsoft OAuth2
export const MICROSOFT_LOGIN = BaseUrl + "/auth/microsoft/login"
export const MICROSOFT_CALLBACK = BaseUrl + "/auth/microsoft/callback"


//Forgot password 

export const FG_SEND_OTP = BaseUrl + "/auth/otp/send-password-reset"
export const FG_RESEND_SEND_OTP = BaseUrl + "/auth/otp/resend-password-reset"
export const FG_VERIFY_OTP = BaseUrl + "/auth/otp/verify-password-reset"
export const FG_RESET_PASSWORD = BaseUrl + "/auth/reset-password-final"




// Tools zeaiq plus
export const TOOLS = BaseUrl + "/tools"
export const TOOLKIT = BaseUrl + "/tools/toolkit"

// Knowledge Bases zeaiq plus

export const KNOWLEDGE_BASE = BaseUrl + "/knowledge/bases"
export const KNOWLEDGE = BaseUrl + "/knowledge"
export const DISCOVER_URLS = BaseUrl + "/knowledge/discover-website-urls"
export const URLS_TASK_STATUS = BaseUrl + "/knowledge/tasks"
export const SHAREPOINT = BaseUrl + "/sharepoint"

// embeddings  zeaiq plus

export const EMBEDDINGS = BaseUrl + "/models/embeddings"
export const MODEL_EMBEDDERS = BaseUrl + "/models/get-all-embedders"

// Chunking  zeaiq plus

export const CHUNK_STRATEGIES = BaseUrl + "/models/chunking-strategies"

// DB types

export const DB_TYPES = BaseUrl + "/models/vector-db-types"


// Agent zeaiq plus 

export const AGENT = BaseUrl + "/agents"

// Workflow zeaiq plus

export const WORKFLOW = {
  GET_WORKFLOWS: BaseUrl + "/workflows",
  EXECUTE_WORKFLOW: BaseUrl + "/workflows/nodes",
  CREATE_WORKFLOW: BaseUrl + "/workflows",
  UPDATE_WORKFLOW: BaseUrl + "/workflows",
  DELETE_WORKFLOW: BaseUrl + "/workflows",
}

// Node-based Workflow zeaiq plus

export const WORKFLOW_NODES = {
  GET_WORKFLOWS: BaseUrl + "/workflows/nodes",
  CREATE_WORKFLOW: BaseUrl + "/workflows/nodes",
  SAVE_WORKFLOW: BaseUrl + "/workflows/nodes/save",
  GET_WORKFLOW: BaseUrl + "/workflows/nodes",
  UPDATE_WORKFLOW: BaseUrl + "/workflows/nodes",
  UPDATE_WORKFLOW_DATA: BaseUrl + "/workflows/nodes",
  DELETE_WORKFLOW: BaseUrl + "/workflows/nodes",
}

export const USER_MEMBER_GROUPS = BaseUrl + "/user-groups/my-memberships"

// models zeaiq plus

export const MODELS = BaseUrl + "/models"
export const ADD_MODELS_ADMIN = BaseUrl + "/admin/add-model"
export const REMOVE_MODEL_ADMIN = BaseUrl + "/admin/remove-model"
export const GET_ALL_MODELS_ADMIN = BaseUrl + "/admin/get-all-models"
export const GET_ALL_MODELS = MODELS + "/get-all-models"
export const UPDATE_MODEL_ADMIN = BaseUrl + "/admin/update-model"


// Providers zeaiq plus

export const PROVIDERS = BaseUrl + "/models/providers"




// Multi Agent or teams or Admin teams

export const TEAMS = BaseUrl + "/teams"

// Admin users
export const ADMIN_USERS = BaseUrl + "/admin/users"


// Admin Organization

export const ADMIN_ORGANIZATIONS = BaseUrl + "/organizations"

// Admin Users and Groups

export const ADMIN_GROUPS = BaseUrl + "/user-groups"


// Multi Agent or teams

export const ADMIN_TEAMS = BaseUrl + "/teams"


// Kay keys

export const API_AKEY = BaseUrl + "/users/me/api-keys"


// DashBord

export const DASHBOARD_AGENT = BaseUrl + "/stats/agents"
export const DASHBOARD_KNOWLEDGE_BASE = BaseUrl + "/stats/knowledge"
export const DASHBOARD_TEAMS = BaseUrl + "/stats/teams"
export const DASHBOARD_ACTIVITY = BaseUrl + "/stats/activity"
export const DASHBOARD_CONVERSATION_METRICS = BaseUrl + "/stats/conversation-metrics"
export const DASHBOARD_STATUS = BaseUrl + "/stats"
export const DASHBOARD_CON_HISTORY = BaseUrl + "/stats/conversation-history"
export const DASHBOARD_CON_EXPORT = BaseUrl + "/stats/export-conversation-data"

// Admin Dashboard
export const DASHBOARD_AGENT_ADMIN = BaseUrl + "/admin_stats/agents"
export const DASHBOARD_KNOWLEDGE_BASE_ADMIN = BaseUrl + "/admin_stats/knowledge"
export const DASHBOARD_STATUS_ADMIN = BaseUrl + "/admin_stats"
export const DASHBOARD_ACTIVITY_ADMIN = BaseUrl + "/admin_stats/activity"
export const DASHBOARD_CONVERSATION_METRICS_ADMIN = BaseUrl + "/admin_stats/conversation-metrics"
export const DASHBOARD_TEAMS_ADMIN = BaseUrl + "/admin_stats/teams"
export const DASHBOARD_CON_HISTORY_ADMIN = BaseUrl + "/admin_stats/conversation-history"
export const DASHBOARD_CON_EXPORT_ADMIN = BaseUrl + "/admin_stats/export-conversation-data"


// Short Cut
export const AGENT_SHORTCUT = BaseUrl + "/agents/post-response-shortcuts"

//History
export const CHAT_HISTORY = BaseUrl + "/chat-history/list"
export const CHAT_HISTORY_DETAIL = `${BaseUrl}/chat-history`;

export const FEEDBACK_POST = `${BaseUrl}/feedbacks/submit-feedback`;
export const FEEDBACK_ANALYTICS = `${BaseUrl}/feedbacks/get-feedback-analytics`;



// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// OLD BACKEND API

// auth 

// export const REGISTER = BaseUrl + "/auth/register"
// export const LOGIN = BaseUrl + "/auth/login"
// export const USER_INFO = AuthBaseUrl + "/me"

export const USERS = BaseUrl + "/users"
export const FORGOT_PASSWORD = BaseUrl + "/forgot-password"
export const RESET_PASSWORD = BaseUrl + "/reset-password"

// Agents old
export const CREATE_AGENT = MetaBaseUrl + "/assistant"
export const LIST_AGENT = MetaBaseUrl + "/assistant"
export const GET_AGENT = MetaBaseUrl + "/assistant"
export const UPDATE_AGENT = MetaBaseUrl + "/assistant"
export const FILE_UPLOAD_AGENT = MetaBaseUrl + "/assistant"
export const DELETE_AGENT = MetaBaseUrl + "/assistant"
export const FILE_DELETE_AGENT = MetaBaseUrl + "/assistant"
export const DOWNLOAD_FILE_AGENT = MetaBaseUrl + "/assistant"

// Chats

export const GET_TABLES = ChatBaseUrl + "/get_tables"
export const RUN_MODEULE = ChatBaseUrl + "/run_module"




// Prompts

export const GET_PROMPTS = MetaBaseUrl + "/prompts"
export const CREATE_PROMPT = MetaBaseUrl + "/prompts"
export const DELETE_PROMPT = MetaBaseUrl + "/prompts"
export const UPDATE_PROMPT = MetaBaseUrl + "/prompts"


// models

export const GET_MODELS_LIST = MetaBaseUrl + "/model-list"
export const GET_MODELS = MetaBaseUrl + "/models"
export const DELETE_MODELS = MetaBaseUrl + "/models"
export const CREATE_MODELS = MetaBaseUrl + "/models"
export const UPDATE_MODELS = MetaBaseUrl + "/models"


// Groups

export const CREATE_GROUP = MetaBaseUrl + "/groups"
export const DELETE_GROUP = MetaBaseUrl + "/groups"
export const GET_GROUP = MetaBaseUrl + "/groups"


// templates

export const CREATE_TEMPLATE = MetaBaseUrl + "/templates"
export const GET_TEMPLATE = MetaBaseUrl + "/templates"
export const GET_TEMPLATES = MetaBaseUrl + "/templates"
export const FILE_UPLOAD_TEMPLATE = MetaBaseUrl + "/templates"
export const FILE_DELETE_TEMPLATE = MetaBaseUrl + "/templates"
export const UPDATE_TEMPLATE = MetaBaseUrl + "/templates"
export const DELETE_TEMPLATE = MetaBaseUrl + "/templates"
export const DOWNLOAD_FILE_TEMPLATE = MetaBaseUrl + "/templates"


// Activites

export const USER_ACTIVITY = MetaBaseUrl + "/activities"

// Audit Log

export const AUDIT_LOG = MetaBaseUrl + "/audit-logs"

// Embed
export const CREATE_EMBED = MetaBaseUrl + "/assistant/apiKey"
export const LIST_EMBED = MetaBaseUrl + "/assistant/apiKey"
export const DELETE_EMBED = MetaBaseUrl + "/assistant/apiKey"
export const UPDATE_EMBED = MetaBaseUrl + "/assistant/apiKey"


// Roles
export const CREATE_ROLE = MetaBaseUrl + "/roles"
export const GET_ROLE = MetaBaseUrl + "/roles"
export const DELETE_ROLE = MetaBaseUrl + "/roles"
export const UPDATE_ROLE = MetaBaseUrl + "/roles"


// Website

export const WEBSITE_LINKS = MetaBaseUrl + "/websites/get-website-links"
export const CREATE_WEBSITE = MetaBaseUrl + "/assistant"
export const UPDATE_WEBSITE = MetaBaseUrl + "/assistant"
export const DELETE_WEBSITE = MetaBaseUrl + "/assistant"